import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${
        size === 'large' ? 'aspect-[3/4]' : 'aspect-[2/3]'
      }`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - yy漫画正版授权`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        {comic.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-md">
            NEW
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <span className="text-xs text-background-50/80 bg-background-950/40 px-2 py-0.5 rounded-full">
            {comic.status}
          </span>
        </div>
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{comic.categoryName}</span>
        </div>
        <div className="flex items-center gap-1.5 mt-1">
          <i className="ri-star-fill text-amber-400 text-xs"></i>
          <span className="text-xs font-medium text-foreground-700">{comic.rating}</span>
          <span className="text-xs text-foreground-400 ml-auto">
            {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}阅读
          </span>
        </div>
      </div>
    </Link>
  );
}